import React from 'react';
import { FiEdit } from 'react-icons/fi';

import { EmptyTableBodyProps } from '../interface';
import { NoDataAvailable } from '../styles';

const EmptyTableBody: React.FC<EmptyTableBodyProps> = ({
  title,
  description,
}) => {
  return (
    <tr>
      <td colSpan={8}>
        <NoDataAvailable>
          <div>
            <FiEdit size="80" color="#6c6c6c" />
          </div>
          <p>{title}</p>
          <span>{description}</span>
        </NoDataAvailable>
      </td>
    </tr>
  );
};

export default EmptyTableBody;
